import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import {
  AccountType,
  Patient,
  PatientRegistration,
  AcceptedValues,
  ValidadeCodeResponse,
  Holder,
} from '../types/en-us'

export const usePatientRegistrationStore = create<PatientRegistration>()(
  persist(
    set => ({
      userData: {} as Patient,
      accountType: null as AccountType,
      userAccess: {} as ValidadeCodeResponse,
      loggedFlow: false,
      isPrivateEligible: false,
      holder: {} as Holder,
      setUserData: (data: Patient) => {
        set({ userData: data })
      },
      setHolder: (data: Holder) => {
        set({ holder: data })
      },
      setAccountType: (selectedAccountType: AccountType) =>
        set({ accountType: selectedAccountType }),
      setUserAccess: (data: ValidadeCodeResponse) => set({ userAccess: data }),
      setLoggedFlow: (logged: boolean) => set({ loggedFlow: logged }),
      setIsPrivateEligible: (isPrivateEligible: boolean) =>
        set({ isPrivateEligible: isPrivateEligible }),
      resetAccountType: () => set({ accountType: null }),
      resetPatientRegistration: () =>
        set({
          userData: {} as Patient,
          accountType: null,
          userAccess: {} as ValidadeCodeResponse,
          loggedFlow: false,
          isPrivateEligible: false,
          holder: {} as Holder,
        }),
      resetUserAccess: () => set({ userAccess: {} as ValidadeCodeResponse }),
      changeUserData: (field: string, value: AcceptedValues) => {
        set(state => ({
          userData: {
            ...state.userData,
            [field]: value,
          },
        }))
      },
      removeUserDataProperty: (field: keyof Patient) => {
        set(state => {
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          const { [field]: removed, ...updatedUserData } = state.userData
          return { userData: updatedUserData as Patient }
        })
      },
      removeUserDataNestedProperty: (path: string) => {
        set(state => {
          const keys = path.split('.')
          const lastKey = keys.pop()
          const nestedObj = keys.reduce((obj, key) => obj[key], state.userData)

          if (nestedObj && lastKey) {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { [lastKey]: removed, ...updatedNestedObj } = nestedObj
            return {
              userData: {
                ...state.userData,
                [keys[0]]: updatedNestedObj,
              },
            }
          }
          return state
        })
      },
    }),
    {
      name: '@ConexaPaciente:patient-registration',
      getStorage: () => sessionStorage,
    },
  ),
)
